import Script from 'next/script';
import React, { FunctionComponent } from 'react';

export const ArticleAudio: FunctionComponent<{ audioId: number }> = ({ audioId }) => {
  return (
    <div>
      <Script
        src="https://proxy.speechkit.io/npm/@speechkit/speechkit-audio-player-v2@latest/dist/module/speechkit-iframe-helper.js"
        strategy="lazyOnload"
      />
      <iframe
        title="Article audio"
        allowFullScreen={false}
        data-src={`https://spkt.io/e/${audioId}`}
        frameBorder="0"
        id="speechkit-io-iframe"
        scrolling="no"
        style={{ display: 'none' }}
      />
    </div>
  );
};
